import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { FileGroup, SelectFieldStatus } from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import {
	ApprenticeInformation,
	AttachmentsGroup,
	FundsInformFields,
	Guarantor_1,
	Guarantor_2,
	InvestorInformation,
} from "../partials/FormFields";

// eslint-disable-next-line no-unused-vars
const CompletedForm = ({ AFdata, setAFdata, updateCurrentObject }) => {
	const [formData, setFormData] = useState(AFdata);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(AFdata);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setAFdata(formData);
		updateCurrentObject(formData);
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar AFdata={formData} action={action} setAction={setAction} handleCancel={handleCancel} />

				<div className='RightSection'>
					<FormAccordion title='Funds Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<FundsInformFields
								formData={formData}
								isEditable={isEditable}
								handleInputChange={handleInputChange}
								except={["approvalStatus", "disbursement"]}
							/>
						</div>
					</FormAccordion>

					<FormAccordion title='ID card'>
						<div className='form-group'>
							<FileGroup name='idCard' value={formData?.user?.idCard} />
						</div>
					</FormAccordion>

					<FormAccordion title='Utility bill'>
						<div className='form-group'>
							<FileGroup name='utilityBill' value={formData?.user?.utilityBill} />
						</div>
					</FormAccordion>

					<FormAccordion title='Proof of purchase'>
						<div className='form-group'>
							<FileGroup value={formData?.proofOfPurchaseDoc?.url} />
						</div>
					</FormAccordion>

					<FormAccordion title='Attachments'>
						<AttachmentsGroup formData={formData} />
					</FormAccordion>

					<FormAccordion title='Investor’s Information'>
						<InvestorInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Apprentice’s Information'>
						<ApprenticeInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Auto debit'>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<SelectFieldStatus
									name='autoDebit'
									value={formData?.autoDebit ? "Enabled" : "Disabled"}
									type={formData?.autoDebit ? "success" : "error"}
								/>
							</div>
						</div>
					</FormAccordion>

					<FormAccordion title='Insurance'>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<SelectFieldStatus
									name='insurance'
									value={formData?.insurance ? "Enabled" : "Disabled"}
									type={formData?.insurance ? "success" : "error"}
								/>
							</div>
						</div>
					</FormAccordion>

					<FormAccordion title='Guarantor 1'>
						<Guarantor_1 formData={formData} />
					</FormAccordion>

					<FormAccordion title='Guarantor 2'>
						<Guarantor_2 formData={formData} />
					</FormAccordion>

					<FormAccordion title='Commitment fee'>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<SelectFieldStatus
									name='commitmentFee'
									// handleChange={handleInputChange}
									// isEditable={isEditable}
									value={"₦" + formData?.commitmentFee}
									type={"success"}
								/>
							</div>
						</div>
					</FormAccordion>
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
CompletedForm.propTypes = {
	AFdata: PropTypes.object,
	setAFdata: PropTypes.func,
	updateCurrentObject: PropTypes.func,
};

export default CompletedForm;
